// extracted by mini-css-extract-plugin
export default {"discount":"lo","order_summary":"mo","line_item":"no","separator":"oo","order__summary_item_title":"po","recurringdis":"qo","get_it_now_button":"ro"};
    if(module.hot) {
      // 1711394575795
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  